<div class="flex flex-col gap-2 pt-2">
  @for (block of blocks(); track block.id) {
    @switch (block.kind) {
      @case ("user") {
        <portal-block-user [content]="block.content" />
      }
      @case ("error") {
        <portal-block-error [content]="block.content" />
      }
      @case ("thought") {
        <portal-block-thought class="block my-1" [steps]="block.steps" />
      }
      @case ("response") {
        <portal-block-response
          [content]="block.content"
          [lsRunId]="block.lsRunId" />
      }
    }
  }

  @if (responding()) {
    <portal-block-thought
      class="block my-1"
      live="true"
      [steps]="liveSteps()" />
    @if (streamingDraft()) {
      <portal-block-response
        [content]="streamingDraft()"
        [showFeedback]="false" />
    }
  }
</div>
